/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ContactoComplementoModeloMS } from './contactoComplementoModeloMS';

export interface ListaContactoModeloMSL { 
    contactoId?: number;
    tipoIdentificacionId?: number;
    contactoNombre?: string;
    tipoIdentificacionDescripcion?: string;
    identificacion?: string;
    numeroCuenta?: string;
    correoElectronico?: string;
    telefono?: string;
    readonly iniciales?: string;
    esInterno?: boolean;
    estaActivo?: boolean;
    contactoComplemento?: ContactoComplementoModeloMS;
}